import type { FC } from 'react'
import { Outlet } from 'react-router-dom'

import Box from '@mui/material/Box'

import useAuth from 'hooks/useAuth'

import { rolesEnum } from 'services/users/types'

import NavigationTabs from 'components/common/NavigationTabs/index'

export const DashboardAnalytics: FC = () => {
  const tabs = [
    { id: 'analytics', label: 'ANALYTICS', allowedRoles: [rolesEnum.Admin, rolesEnum.Manager] },
  ]
  const { user } = useAuth()
  const filteredTabs = tabs.filter((tab) => user && tab.allowedRoles.includes(user?.roleId))
  return (
    <Box sx={{ height: 'calc(100vh - 80px)' }}>
      <NavigationTabs tabs={filteredTabs} basePath="/dashboard-analytics" />
      <Outlet />
    </Box>
  )
}
